import { render } from "./ClassFolder.vue?vue&type=template&id=212e4184"
import script from "./ClassFolder.vue?vue&type=script&lang=js"
export * from "./ClassFolder.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__